var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85759 0.847917C9.38326 0.384028 8.61295 0.384028 8.13862 0.847917L3.28147 5.59815C2.80714 6.06204 2.80714 6.8154 3.28147 7.27929C3.7558 7.74318 4.52612 7.74318 5.00045 7.27929L7.78571 4.55533V12.3747C7.78571 13.0315 8.32835 13.5622 9 13.5622C9.67165 13.5622 10.2143 13.0315 10.2143 12.3747V4.55533L12.9996 7.27929C13.4739 7.74318 14.2442 7.74318 14.7185 7.27929C15.1929 6.8154 15.1929 6.06204 14.7185 5.59815L9.86138 0.847917H9.85759ZM2.92857 13.5622C2.92857 12.9053 2.38594 12.3747 1.71429 12.3747C1.04263 12.3747 0.5 12.9053 0.5 13.5622V15.9373C0.5 17.9042 2.1317 19.5 4.14286 19.5H13.8571C15.8683 19.5 17.5 17.9042 17.5 15.9373V13.5622C17.5 12.9053 16.9574 12.3747 16.2857 12.3747C15.6141 12.3747 15.0714 12.9053 15.0714 13.5622V15.9373C15.0714 16.5942 14.5288 17.1249 13.8571 17.1249H4.14286C3.47121 17.1249 2.92857 16.5942 2.92857 15.9373V13.5622Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6c4fb8a0ad0a5c9af91a3d8825035b54.svg";
export { ForwardRef as ReactComponent };